<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        class="mt-3"
      >
        <h4>Configuração de envio de e-mail</h4>
        <fieldset class="font-weight-bold text-muted small">
          Informações para envio de e-mail
        </fieldset>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <hr
          class="mx-0 mt-0 mb-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
      </b-col>
    </b-row>
    <b-row style="height:5rem">
      <b-form-group
        label="Remetente (e-mail)"
        class="col-md-6"
        :valid-feedback="validFeedback"
        :invalid-feedback="invalidFeedback"
        :state="state"
      >
        <validation-provider
          #default="{ errors }"
          name="'remetente (e-mail)'"
          rules="required|email"
        >
          <b-form-input
            ref="smtpEmail"
            v-model="email"
            :disabled="naoEditarEmail || logadoGoogle"
            :state="(errors.length > 0) ? false : null"
            @change="sendToParent"
          />
          <small
            class="text-danger"
            style="float:left;"
          >{{ setMensagemErro(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>
      <b-col cols="6">
        <b-form-group label="Senha">
          <senha-input
            ref="smtpSenha"
            v-model="senha"
            :validacao-nome="'smtpSenha'"
            :blur-function="validarSMTP"
            :change-function="sendToParent"
            :disabled="logadoGoogle || usarGoogle"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-form-group
        class="col-md-6 mt-2"
      >
        <b-button
          v-if="!usarGoogle"
          variant="primary"
          :disabled="(email == '' || senha == '')"
          @click="validarSMTP()"
        >
          {{ buttonText }}
        </b-button>
        <b-btn
          v-if="!logadoGoogle && usarGoogle"
          variant="none"
          :class="['login-with-google-btn', { 'logado': logadoGoogle }]"
          :disabled="(!email || email == '' || !userId || userId === 0) && !naoEditarEmail"
          @click="loginGoogle"
        >
          Logar com o Google
        </b-btn>
        <b-btn
          v-if="logadoGoogle && usarGoogle"
          variant="none"
          :class="['login-with-google-btn', { 'logado': logadoGoogle }]"
          @click="signOutGoogle()"
        >
          Deslogar do Google
        </b-btn>
      </b-form-group>
    </b-row>
  </div>
</template>

<style lang="scss">
.loading {
  background-image: url('~@/assets/gifs/loading.gif');
  background-repeat: no-repeat;
  background-size: 8%;
  background-position: right;
}

.login-with-google-btn {
  transition: background-color .3s, box-shadow .3s;

  padding: 12px 16px 12px 42px;
    border: 1px solid rgb(255, 0, 0);
  border-radius: 3px;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25);

  color: #757575;
  font-size: 14px;
  font-weight: 500;

  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=);
  background-color: white;
  background-repeat: no-repeat;
  background-position: 12px 11px;

  &:hover {
    box-shadow: 0 -1px 0 rgba(0, 0, 0, .04), 0 2px 4px rgba(0, 0, 0, .25);
  }

  &:active {
    background-color: #eeeeee;
  }

  &:focus {
    outline: none;
    box-shadow:
      0 -1px 0 rgba(0, 0, 0, .04),
      0 2px 4px rgba(0, 0, 0, .25),
      0 0 0 3px #c8dafc;
  }
}

.logado {
  border: 1px solid #28c76f;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@/app-modulo/comuns/usuario-interno/shared/services/api'

export default {
  name: 'DadosSmtp',
  components: {
    ValidationProvider,
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
  },
  props: {
    email: {
      type: String,
      default: '',
    },
    senha: {
      type: String,
      default: '',
    },
    userId: {
      type: [String, Number],
      default: null,
    },
    validado: {
      type: Boolean,
      default: null,
    },
    usuarioValidou: {
      type: String,
      default: '',
    },
    dataValidacao: {
      type: String,
      default: '',
    },
    naoEditarEmail: {
      type: Boolean,
      default: false,
    },
    logadoGoogle: {
      type: Boolean,
      default: false,
    },
    usarGoogle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      smtpValido: null,
      buttonText: '',
      invalidFeedback: '',
      validFeedback: '',
    }
  },
  computed: {
    ...mapGetters('cadastroBase', ['desabilitarBotao']),
    state() {
      return this.smtpValido
    },
  },
  created() {
    this.buttonText = 'Validar credenciais de SMTP'

    if (this.userId) {
      this.smtpValido = this.validado
      this.invalidFeedback = this.validado || this.usarGoogle ? '' : `Credencial não validada - ${this.usuarioValidou} - ${this.dataValidacao}`
      this.validFeedback = this.validado && !this.usarGoogle ? `Credencial validada - ${this.usuarioValidou} - ${this.dataValidacao}` : ''
    }
  },
  methods: {
    ...mapActions('cadastroBase', ['setDesabilitarBotao']),
    validarSMTP() {
      if (this.email !== '' && this.senha !== '') {
        this.setDesabilitarBotao(true)
        this.invalidFeedback = ''
        this.validFeedback = ''
        this.$refs.smtpEmail.$el.classList.value = 'form-control loading'
        api.validaSMTP(this.userId, this.email, this.senha)
          .then(payload => {
            const smtp = payload.data
            if (smtp.validado) {
              this.smtpValido = true
              this.validFeedback = `Credencial validada - ${smtp.usuarioValidou} - ${smtp.dataValidacao}`
              this.$refs.smtpEmail.$el.classList.value = 'form-control is-valid'
            } else {
              this.smtpValido = false
              this.invalidFeedback = `Credencial não validada - ${smtp.usuarioValidou} - ${smtp.dataValidacao}`
              this.$refs.smtpEmail.$el.classList.value = 'form-control is-invalid'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Credencial de e-mail não validada',
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
            }
            this.setDesabilitarBotao(false)
            this.validado = this.smtpValido
            this.usuarioValidou = smtp.usuarioValidou
            this.dataValidacao = smtp.dataValidacao
            this.sendToParent()
          })
      }
    },
    sendToParent() {
      this.$emit('input', {
        smtpEmail: this.email,
        smtpSenha: this.senha,
        validado: this.validado,
        usuarioValidou: this.usuarioValidou,
        dataValidacao: this.dataValidacao,
      })
    },
    setMensagemErro(erro) {
      if (erro) {
        this.$refs.smtpEmail.$el.classList.value = 'form-control is-invalid'
        this.smtpValido = null
        return erro
      }
      return ''
    },
    loginGoogle() {
      if (!this.naoEditarEmail) {
        const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const success = re.test(this.email)
        if (success) {
          this.$emit('email-google')
        }
      } else if (this.naoEditarEmail) {
        this.$emit('email-google')
      }
    },
    signOutGoogle() {
      this.$emit('sign-out')
    },
  },
}
</script>
